// src/API/auth/recityAuth.ts
import axios from "axios";

export async function loginToReCity(username: string, password: string) {
  const body = { username, password, frmAPI: "web" };

  const res = await axios.post("https://api.recity.in/api/users/login", body);

  const bearer = res?.data?.token;
  if (!bearer) throw new Error("ReCity token missing");

  const cleaned = bearer.replace(/^Bearer\s+/i, "").trim();

  localStorage.setItem("jwtTokenReCity", bearer); 
  localStorage.setItem("authToken", cleaned);     

  const name = res?.data?.data?.name;
  if (name) localStorage.setItem("loggedInName", name);

  const uid = res?.data?.data?.userID;
  if (uid) localStorage.setItem("loggedInUserId", uid);

  return cleaned;
}
